import { SAMPLE } from "../constants";
import { instance } from "../../axios";

let getSamples = () => {
  return async (dispatch) => {
    dispatch({
      type: SAMPLE.SAMPLE_GET_ALL,
    });
    try {
      const results = await instance.get("/sample");
      dispatch({
        type: SAMPLE.SAMPLE_GET_ALL_SUCCESS,
        payload: results.data,
      });
    } catch (error) {
      dispatch({
        type: SAMPLE.SAMPLE_GET_ALL_FAILURE,
        payload: error,
      });
    }
  };
};

let getSamplesByCenter = (centerId) => {
  return async (dispatch) => {
    dispatch({
      type: SAMPLE.SAMPLE_GET_ALL,
    });
    try {
      const results = await instance.get(`/sample/center/${centerId}`);
      dispatch({
        type: SAMPLE.SAMPLE_GET_ALL_SUCCESS,
        payload: results.data,
      });
    } catch (error) {
      dispatch({
        type: SAMPLE.SAMPLE_GET_ALL_FAILURE,
        payload: error,
      });
    }
  };
};

let getSample = (id) => {
  return async (dispatch) => {
    dispatch({
      type: SAMPLE.SAMPLE_GET_ONE,
    });
    try {
      const results = await instance.get(`/sample/${id}`);
      dispatch({
        type: SAMPLE.SAMPLE_GET_ONE_SUCCESS,
        payload: results.data,
      });
      return results.data;
    } catch (error) {
      dispatch({
        type: SAMPLE.SAMPLE_GET_ONE_FAILURE,
        payload: error,
      });
      throw error;
    }
  };
};

let getSamplesByPatientId = async (patientId) => {
  return (dispatch) => {
    dispatch({
      type: SAMPLE.SAMPLE_GET_ALL,
    });
    instance({
      method: "GET",
      url: `/sample/patient/${patientId}`,
    })
      .then((results) => {
        dispatch({
          type: SAMPLE.SAMPLE_GET_ALL_SUCCESS,
          payload: results.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: SAMPLE.SAMPLE_GET_ALL_FAILURE,
          payload: error,
        });
      });
  };
};

let createSample = (body) => {
  return async (dispatch) => {
    dispatch({
      type: SAMPLE.SAMPLE_CREATE,
    });
    try {
      const results = await instance.post("/sample", body);
      dispatch({
        type: SAMPLE.SAMPLE_CREATE_SUCCESS,
        payload: results.data,
      });
      return results;
    } catch (error) {
      dispatch({
        type: SAMPLE.SAMPLE_CREATE_FAILURE,
        payload: error,
      });
      throw error;
    }
  };
};

let editSample = (id, body) => {
  return async (dispatch) => {
    dispatch({
      type: SAMPLE.SAMPLE_UPDATE,
    });
    try {
      const results = await instance.put(`/sample/${id}`, body);
      dispatch({
        type: SAMPLE.SAMPLE_UPDATE_SUCCESS,
        payload: results.data,
      });
      return results.data;
    } catch (error) {
      dispatch({
        type: SAMPLE.SAMPLE_UPDATE_FAILURE,
        payload: error,
      });
      throw error;
    }
  };
};

let deleteSample = (id) => {
  return async (dispatch) => {
    dispatch({
      type: SAMPLE.SAMPLE_DELETE,
    });
    try {
      const results = await instance.delete(`/sample/${id}`);
      dispatch({
        type: SAMPLE.SAMPLE_DELETE_SUCCESS,
        payload: results.data,
      });
      return results.data;
    } catch (error) {
      dispatch({
        type: SAMPLE.SAMPLE_DELETE_FAILURE,
        payload: error,
      });
      throw error;
    }
  };
};

export {
  getSamplesByPatientId,
  getSamplesByCenter,
  createSample,
  editSample,
  deleteSample,
};
export { getSamples, getSample };
